<template>
  <div class="image-container ">
    <img src="../../../public/fondo.png" alt="" class="background-image" />
    <div class="container">
      <div v-if="currentStep === 1">
        <div class="card-container mt-5">
          <div class="card-title d-flex justify-content-center">
            <img
              src="../../../public/paso1.png"
              height="40px"
              class="card-title d-flex justify-content-center"
              alt=""
            />
          </div>
          <div class="card mb-3">
            <div class="card-header">
              <h3 class="card-title d-flex justify-content-center fw-bold">
                <strong>COMPRUEBA TUS DATOS</strong>
              </h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="row g-0">
                  <div class="col-md-4">
                    <img
                      v-if="
                        form_update.url_image != null &&
                        form_update.url_image != undefined &&
                        form_update.url_image != '' &&
                        form_update.url_image != 'prueba'
                      "
                      class="card-img-top mx-auto d-block mt-2"
                      :src="form_update.url_image"
                      style="
                        height: 100px;
                        width: 100px;
                        text-align: center;
                        border-radius: 50px;
                      "
                    />
                    <img
                      v-else
                      class="card-img-top mx-auto d-block mt-2"
                      src="https://static.vecteezy.com/system/resources/thumbnails/008/442/086/small_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg"
                      onerror="this.onerror=null;src=this.default_img"
                      style="
                        height: 100px;
                        width: 100px;
                        text-align: center;
                        border-radius: 50px;
                      "
                    />
                  </div>
                  <div class="col-md-8">
                    <div class="row g-0">
                      <div
                        class="col-md-6 text-md-start text-center py-3 py-md-0"
                      >
                        <h4
                          class="card-text"
                          style="color: black !important; font-size: medium"
                        >
                          Nombre y apellido
                        </h4>
                        <h5
                          class="card-title fw-bold mt-1"
                          style="color: black !important"
                        >
                          <strong
                            >{{ form_update.first_name }}
                            {{ form_update.last_name }}</strong
                          >
                        </h5>
                        <h4
                          class="card-text mt-2"
                          style="color: black !important; font-size: medium"
                        >
                          Correo
                        </h4>
                        <h5
                          class="card-title fw-bold mt-1"
                          style="color: black !important"
                        >
                          <strong>{{ form_update.email }}</strong>
                        </h5>
                      </div>
                      <div class="col-md-6 text-md-start text-center">
                        <h4
                          class="card-text"
                          style="color: black !important; font-size: medium"
                        >
                          Fecha de registro
                        </h4>
                        <h5
                          class="card-title fw-bold mt-1"
                          style="color: black !important"
                        >
                          <strong>{{
                            formatDate(form_update.created_at)
                          }}</strong>
                        </h5>
                        <h4
                          class="card-text mt-2"
                          style="color: black !important; font-size: medium"
                        >
                          Teléfono
                        </h4>
                        <h5
                          class="card-title fw-bold mt-1"
                          style="color: black !important"
                        >
                          <strong>{{ form_update.phone_1 }}</strong>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="form-group mt-4 px-auto mx-auto"
                  style="width: 300px !important"
                >
                  <label for="exampleInputEmail1">Selecciona un vehículo</label>

                  <select class="form-control" v-model="selectedVehicle" @change="updateStatus">
                    <option :value="vehicle" v-for="vehicle in vehiclesTmp" :key="vehicle.id"
                     >
                   <span v-if="vehicle.type_brand">{{ vehicle.type_brand.name }}</span> - <span>{{ vehicle.plate }}</span>
                  
                  </option>
                  </select>
                 
                </div>
                <div v-if="selectedVehicle" class="row g-0">
                  <div class="col-md-4">
                    <img
                      v-if="
                        selectedVehicle.url_image != null &&
                        selectedVehicle.url_image != undefined &&
                        selectedVehicle.url_image != '' &&
                        selectedVehicle.url_image != 'prueba'
                      "
                      class="card-img-top mx-auto d-block mt-2"
                      :src="selectedVehicle.url_image"
                      onerror="this.onerror=null;src=this.default_img"
                      style="
                        height: 100px;
                        width: 100px;
                        text-align: center;
                        border-radius: 20px;
                      "
                    />
                    <img
                      v-else
                      class="card-img-top mx-auto d-block mt-2"
                      src="https://play-lh.googleusercontent.com/Fa-hPHOekHE_3QxlVqjlnz1SCnwEye8BAVsqcHX4tzFTdiY9hM6U1FO1hc1YyTYWh0o=s200"
                      style="
                        height: 140px;
                        width: 140px;
                        text-align: center;
                        border-radius: 20px;
                      "
                    />
                  </div>
                  <div class="col-md-8">
                    <div class="row g-0">
                      <div
                        class="col-md-6 text-md-start text-center py-3 py-md-0"
                      >
                      <h4
                          class="card-text mt-2"
                          style="color: black !important; font-size: medium"
                        >
                          Marca del vehículo
                        </h4>
                        <h5
                          class="card-title fw-bold"
                          style="color: black !important"
                          v-if="selectedVehicle.type_brand != null"
                        >
                          <strong>{{ selectedVehicle.type_brand.name }}</strong>
                        </h5>
                        <h4
                          class="card-text mt-2"
                          style="color: black !important; font-size: medium"
                        >
                          Modelo del vehículo
                        </h4>
                        <h5
                          class="card-title fw-bold"
                          style="color: black !important"
                          v-if="selectedVehicle.type_model != null"
                        >
                          <strong>{{ selectedVehicle.type_model.name }}</strong>
                        </h5>

                        <h4
                          class="card-text mt-2"
                          style="color: black !important; font-size: medium"
                        >
                          Placa del vehículo
                        </h4>
                        <h5
                          class="card-title fw-bold"
                          style="color: black !important"
                        >
                          <strong>{{ selectedVehicle.plate }}</strong>
                        </h5>
                      </div>
                      <div class="col-md-6 text-md-start text-center">
                        <h4
                          class="card-text mt-2"
                          style="color: black !important; font-size: medium"
                        >
                          Color del vehículo
                        </h4>
                        <h5
                          class="card-title fw-bold"
                          style="color: black !important"
                        >
                          <strong>{{ selectedVehicle.color }} </strong>
                        </h5>
                        <h4
                          class="card-text mt-2"
                          style="color: black !important; font-size: medium"
                        >
                          Año del vehículo
                        </h4>
                        <h5
                          class="card-title fw-bold"
                          style="color: black !important"
                        >
                          <strong>{{ selectedVehicle.year }}</strong>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row p-3 mx-auto" style="color:black">
                  <div class="col-md-2">
                  </div>
                  <div class="col-md-8 border rounded-3 p-3 mx-auto" v-if="lastAppointment">
                    <p class="mx-auto text-center" v-if="lastAppointment">Tú ultima cita en el sistema fue el: {{ lastAppointment.date | formatDate }} y se encuentra en estatus: <br><span v-if="lastAppointment.type_appointment_status"><strong>{{ lastAppointment.type_appointment_status.name }}</strong></span>, si realmente estás seguro de crear otra cita presiona continuar</p>
                 
                  </div>
                  <div class="col-md-2">
                  </div>
                  </div>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
            
              <button
                @click="nextStep"
                class="btn btn-primary"
                :disabled="!selectedVehicle"
                style="
                  background: #8cc540 !important;
                  border-radius: 20px !important;
                "
              >
                <strong>Continuar</strong>
              </button>
            </div>
            <div class="d-flex justify-content-center mt-3">
              <a
                @click="showWarningAlert"
                style="
                  cursor: pointer !important;
                  color: black !important;
                  margin-bottom: 5px;
                "
                >Mis datos no son correctos</a
              >
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentStep === 2">
        <div class="card-container mt-5">
          <div class="card-title d-flex justify-content-center">
            <img
              src="../../../public/paso2.png"
              height="40px"
              class="card-title d-flex justify-content-center"
              alt=""
            />
          </div>
          <div class="card mb-3">
            <div class="card-header">
              <h3 class="card-title d-flex justify-content-center fw-bold">
                <strong>Selecciona un horario</strong>
              </h3>
              <h6
                class="card-text d-flex justify-content-center"
                style="color: black !important"
              >
                Elije el dia y bloque de horas para tu cita.
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  class="form-group mt-4 px-auto mx-auto text-center"
                  style="width: 300px !important"
                >
                  <label for="exampleInputEmail1"
                    >Selecciona un dia de la semana</label
                  >
                  <multiselect
                    selectLabel="Seleccionar"
                    selectedLabel=""
                    deselectLabel="Remover"
                    :searchable="false"
                    placeholder="Seleccionar"
                    :select-label="'Seleccionar'"
                    v-model="day_selected"
                    :options="dayTmp"
                    label="name"
                    style="color: black !important"
                    @input="loadSchedules()"
                  ></multiselect>
                  <div>
                    <br>
                    <label v-if="schedulesTmp.length > 0">Selecciona un bloque de hora</label>

                    <label v-if="schedulesTmp.length == 0"><strong>No hay horarios en el bloque seleccionado</strong></label>
                    <div
                      v-for="schedule in schedulesTmp"
                      :key="schedule.id"
                      class="form-group mt-4 px-auto mx-auto text-center"
                    >
                      <button
                        v-on:click="toggleHorario(schedule)"
                        :class="{
                          'btn btn-lg': true,
                          'btn-secondary': !isHorarioActive(schedule),
                          'btn-light': isHorarioActive(schedule),
                          active: isHorarioActive(schedule),
                        }"
                        style="border-radius: 50px !important"
                      >
                        {{
                          schedule.day +
                          " - " +
                          formatHour(schedule.start_hour) +
                          " - " +
                          formatHour(schedule.end_hour)
                        }}
                      </button>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
              <button
                @click="prevStep"
                class="btn btn-primary"
                style="
                  margin-right: 5px;
                  background: #5f5e5c !important;
                  border-radius: 20px !important;
                "
              >
                <strong>Anterior</strong>
              </button>

              <button
                @click="nextStep"
                class="btn btn-primary"
                :disabled="!selectedSchedule.id > 0"
                style="
                  background: #8cc540 !important;
                  border-radius: 20px !important;
                "
              >
                <strong>Continuar</strong>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentStep === 3">
        <div class="card-container mt-5" >
          <div class="card-title d-flex justify-content-center">
            <img
              src="../../../public/paso3.png"
              height="40px"
              class="card-title d-flex justify-content-center"
              alt=""
            />
          </div>
          <div class="card mb-3">
            <div class="card-header">
              <h3 class="card-title d-flex justify-content-center fw-bold">
                <strong
                  >Agenda el dia y hora en:
                  {{
                    selectedSchedule.name +
                    " - " +
                    formatHour(selectedSchedule.start_hour) +
                    " - " +
                    formatHour(selectedSchedule.end_hour)
                  }}</strong
                >
              </h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  class="fecha-hora-container mt-4 mt-5"
                  style="margin-bottom: 160px"
                >
                  <div class="row">
                    <div class="row g-0">
                      <div class="row col-md-1"></div>
                      <div class="row col-md-6 text-center mt-4">
                   
 <p style="color:black" class="px-5">1. Selecciona el Día de la cita<br>{{ formatDate(this.selectedDate)}}</p>
                        
                        <div
                          v-for="futureDate in futureDates"
                          :key="futureDate"
                        >
                          <button
                            :class="{
                              'btn btn-lg m-3': true,
                              'btn-secondary': selectedDate !== futureDate
                            }"
                            :style="selectedDate === futureDate ? 'background-color: #F0C505 !important; border-color: #F0C505 !important; color: #000;' : ''"
                            style="border-radius: 50px !important"
                            @click="setDate(futureDate)"
                          >
                            {{ formatDate(futureDate) }}
                          </button>
                        </div>
                      </div>
                      <div class="row col-md-5 text-center mt-4">
                        <p style="color:black" class="px-5">2. Indíca la hora exacta para: <br>{{ formatDate(this.selectedDate)}}</p>
                        
                        <div v-if="!selectedSchedule || !selectedSchedule.start_hour" class="alert alert-warning">
                          Por favor, selecciona primero un horario
                        </div>
                        <div v-else class="available-hours-container">
                          <div class="row justify-content-center">
                            <div v-for="hour in availableHoursFormatted" :key="hour.value" class="col-auto mb-2">
                              <button 
                                class="btn btn-lg m-1" 
                                :class="{'btn-secondary': selectedHour !== hour.value}"
                                :style="selectedHour === hour.value ? 'background-color: #F0C505 !important; border-color: #F0C505 !important; color: #000;' : ''"
                                style="border-radius: 50px !important; min-width: 100px;"
                                @click="selectHour(hour.value, hour.label)"
                              >
                                {{ hour.label }}
                              </button>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="card-footer d-flex justify-content-start">
            <button @click="prevStep" class="btn btn-primary">Anterior</button>
          </div> -->
            <div class="card-footer d-flex justify-content-end">
              <button
                @click="prevStep"
                class="btn btn-primary"
                style="
                  margin-right: 5px;
                  background: #5f5e5c !important;
                  border-radius: 20px !important;
                "
              >
                <strong>Anterior</strong>
              </button>

              <button
                @click="nextStep"
                class="btn btn-primary"
                :disabled="!selectedTime"
                style="
                  background: #8cc540 !important;
                  border-radius: 20px !important;
                "
              >
                <strong>Continuar</strong>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentStep === 4">
        <div class="card-container mt-5">
          <div class="card-title d-flex justify-content-center">
            <img
              src="../../../public/paso4.png"
              height="40px"
              class="card-title d-flex justify-content-center"
              alt=""
            />
          </div>
          <div class="card mb-3">
            <div class="card-header">
              <h3 class="card-title d-flex justify-content-center fw-bold">
                <strong>Valida tus datos</strong>
              </h3>
            </div>
            <div
              class="card-body mt-4"
              style="
                background-color: #f8f8f8;
                border-radius: 20px !important;
                box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.5);
                margin-left: 40px;
                margin-right: 40px;
              "
            >
              <div class="row">
                <div class="row g-0">
                  <div class="col-md-3">
                    <img
                      v-if="
                        selectedVehicle.url_image != null &&
                        selectedVehicle.url_image != undefined &&
                        selectedVehicle.url_image != '' &&
                        selectedVehicle.url_image != 'prueba'
                      "
                      class="card-img-top mx-auto d-block mt-2"
                      :src="selectedVehicle.url_image"
                      onerror="this.onerror=null;src=this.default_img"
                      style="
                        height: 100px;
                        width: 100px;
                        text-align: center;
                        border-radius: 20px;
                      "
                    />
                    <img
                      v-else
                      class="card-img-top mx-auto d-block mt-2"
                      src="../../../public/LogopricipalChami.png"
                      style="
                        height: 140px;
                        width: 140px;
                        text-align: center;
                        border-radius: 20px;
                      "
                    />
                  </div>
                  <div
                    v-if="selectedVehicle"
                    class="col-md-3 text-md-start text-center py-3 py-md-0"
                  >
                    <h5 class="card-title" style="color: black !important">
                      Color:<strong>{{ selectedVehicle.color }} </strong>
                    </h5>

                    <h5 class="card-title" style="color: black !important">
                      Modelo:<strong>{{ selectedVehicle.name }}</strong>
                    </h5>
                    <h5 class="card-title" style="color: black !important">
                      Año: <strong>{{ selectedVehicle.year }}</strong>
                    </h5>

                    <h5 class="card-title" style="color: black !important">
                      Placa: <strong>{{ selectedVehicle.plate }}</strong>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <img
                      v-if="
                        form_update.url_image != null &&
                        form_update.url_image != undefined &&
                        form_update.url_image != '' &&
                        form_update.url_image != 'prueba'
                      "
                      class="card-img-top mx-auto d-block mt-2"
                      :src="form_update.url_image"
                      style="
                        height: 100px;
                        width: 100px;
                        text-align: center;
                        border-radius: 50px;
                      "
                    />
                    <img
                      v-else
                      class="card-img-top mx-auto d-block mt-2"
                      src="https://static.vecteezy.com/system/resources/thumbnails/008/442/086/small_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg"
                      onerror="this.onerror=null;src=this.default_img"
                      style="
                        height: 100px;
                        width: 100px;
                        text-align: center;
                        border-radius: 50px;
                      "
                    />
                  </div>

                  <div class="col-md-4 text-md-start text-center py-3 py-md-0">
                    <h5 class="card-title mt-1" style="color: black !important">
                      <strong
                        >{{ form_update.first_name }}
                        {{ form_update.last_name }}</strong
                      >
                    </h5>
                    <h5 class="card-title mt-1" style="color: black !important">
                      <strong>{{ formatDate(form_update.created_at) }}</strong>
                    </h5>
                    <h5 class="card-title mt-1" style="color: black !important">
                      <strong>{{ form_update.email }}</strong>
                    </h5>

                    <h5 class="card-title mt-1" style="color: black !important">
                      <strong>{{ form_update.phone_1 }}</strong>
                    </h5>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body mt-4" style="margin-bottom: 80px">
              <div class="row">
                <div class="row g-0">
                  <div class="col-md-3"></div>
                  <div class="col-md-3 justify-content-center text-center">
                    <h4
                      class="card-text"
                      style="color: black !important; font-size: medium"
                    >
                      Dia de la cita
                    </h4>
                    <div
                      class="card-title mt-1 text-center"
                      disabled
                      style="
                        border-radius: 20px !important;
                        background-color: silver;
                        height: 30px;
                      "
                    >
                      <strong>{{ formatDate(selectedDate) }}</strong>
                    </div>
                   
                  </div>
                  <div class="col-md-3 justify-content-center text-center">
                    <h4
                      class="card-text"
                      style="color: black !important; font-size: medium"
                    >
                      Hora
                    </h4>
                    
                    <div
                      class="card-title text-center mt-1"
                      disabled
                      style="
                        border-radius: 20px !important;
                        background-color: silver;
                        height: 30px;
                      "
                    >
                      <strong
                        >{{ selectedTime.hh }}:{{ selectedTime.mm }} {{ selectedTime.A }}</strong
                      >
                    </div>
                    <p style="font-size:11px; color:black">El tiempo de inspección tarda apróximadamente una hora, es posible que otros conductores deban ser inspeccionados en el horario seleccionado.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
              <button
                @click="prevStep"
                class="btn btn-primary"
                style="
                  margin-right: 5px;
                  background: #5f5e5c !important;
                  border-radius: 20px !important;
                "
              >
                <strong>Anterior</strong>
              </button>

              <button
                @click="
                  saveSchedul(
                    selectedVehicle,
                    form_update,
                    selectedTime
                  )
                "
                class="btn btn-primary"
                style="
                  background: #8cc540 !important;
                  border-radius: 20px !important;
                "
              >
                <strong>Agendar</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
      rel="stylesheet"
      integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
      crossorigin="anonymous"
    />
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Cookies from "js-cookie";
import moment from "moment";
import Multiselect from "vue-multiselect";

// CSS
// import 'vue2-timepicker/dist/VueTimepicker.css'
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import VueTimepicker from "vue2-timepicker";
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  components: {
    DatePicker,
    VueTimepicker,
    Multiselect,
  },
  data() {
    return {
      allowedDays: [1, 3, 5],
      form_update: {
        id: 0,
        type_vehicle: {},
        type_brand: {},
        type_model: {},
        user: {},
        name: "",
        plate: "",
        url_image: "",
        year: "",
        number_door: "",
        color: "",
        air_conditioning: "",
        smoke_glasses: "",
        vehicles: "",
      },
      form_update_day: {
        day: "",
        hour: "",
      },
      selectBlock: "",
      selecthourBloCK: "",
      currentStep: 1,
      vehiclesTmp: [],
      day_selected: null,
      dayTmp: [
        {
          id: 1,
          name: "Lunes",
        },
        {
          id: 2,
          name: "Martes",
        },
        {
          id: 3,
          name: "Miercoles",
        },
        {
          id: 4,
          name: "Jueves",
        },
        {
          id: 5,
          name: "Viernes",
        },
        {
          id: 6,
          name: "Sabado",
        },
        {
          id: 7,
          name: "Domingo",
        },
      ],

      hourTmp: [],
      selectedVehicle: null,
      selectedShift: null,
      daysOptions: [
        { value: "Lunes", label: "Lunes" },
        { value: "Martes", label: "Martes" },
        { value: "Miércoles", label: "Miércoles" },
        { value: "Jueves", label: "Jueves" },
        { value: "Viernes", label: "Viernes" },
      ],
      selectedDays: [],
      selectedSchedule: "null", // Initial selected state
      isHorarioSelected: false,
      horarioStates: {
        manana: false, // Track active state for each horario
        tarde: false,
      },
      selectedDate: null,

      selectedTime: null,
      selectedHour: null,
      schedulesTmp: [],
      model: {
        email: "",
        password: "",
      },
      futureDates: [],
      lastAppointment: null,
    };
  },
  filters: {
    formatDate(date) {
      if(date){
        return moment(date).format("DD/MM/YYYY");
      }
      else{
        return "";
      }
    },
  },
  mounted() {
    const url = this.$route.path; // Use path instead of params
    const ultimoParametro = url.split("/").pop();
    this.loadElements(ultimoParametro);
  
    // this.updateDisabledDates();
    //this.generateFutureDates();
  },
  computed: {
    formatDate3() {
      if (!this.selectedDate) {
        return ""; // Handle empty date
      }

      const options = { year: "numeric", month: "2-digit", day: "2-digit" }; // Adjust format as needed

      // Use 'es-ES' locale for Spanish (DD/MM/YYYY)
      return new Date(this.selectedDate).toLocaleDateString("es-ES", options);
    },
    availableHoursFormatted() {
      if (!this.selectedSchedule || !this.selectedSchedule.start_hour) {
        return [];
      }
      
      let start_hour = this.selectedSchedule.start_hour;
      let end_hour = this.selectedSchedule.end_hour;
      
      // Get only hour on int format
      start_hour = parseInt(start_hour.substring(0, 2));
      end_hour = parseInt(end_hour.substring(0, 2));
      
      let hours = [];
      // Generate hours range with formatted labels
      for (let i = start_hour; i <= end_hour; i++) {
        let hour = i;
        let period = "AM";
        let displayHour = hour;
        
        if (hour >= 12) {
          period = "PM";
          if (hour > 12) {
            displayHour = hour - 12;
          }
        }
        if (hour === 0) {
          displayHour = 12;
        }
        
        hours.push({
          value: i,
          label: `${displayHour}:00 ${period}`
        });
      }
      
      return hours;
    },
    getHourRange(){
      let start_hour = this.selectedSchedule.start_hour;
      let end_hour = this.selectedSchedule.end_hour;
      console.log(start_hour, end_hour)
      //Get only hour on int format
      start_hour = start_hour.substring(0, 2);
      start_hour = parseInt(start_hour);
      end_hour = end_hour.substring(0, 2);
      end_hour = parseInt(end_hour);
      let hourTmp = [];
      //Generate hours range
      for (let i = start_hour; i <= end_hour ; i++) {
        console.log(i)
        let hour = i;
        if (i < "12") {
          console.log('Set hour to a')
          hour =  hour+"a";
        }else{
          console.log('Set hour to p')
          hour =  hour+"p";
        }
        hourTmp.push(i);
      }
      console.log(hourTmp)
      return hourTmp;

    },
    handleHourChange(selectedHour, selectedMinute) {
      // Tu código aquí
      console.log(this.selectedTime, "horarios");
      this.selecthourBloCK == this.selectedTime;
      console.log(`Hora seleccionada: ${selectedHour}:${selectedMinute}`);
    },
    isAfternoon() {
      return this.selectBlock.end_hour >= "12:00";
    },
    isMorning() {
      return this.selectBlock.start_hour < "12:00";
    },
    formattedTime() {
      const HH = this.selectedTime.HH;
      const mm = this.selectedTime.mm;

      const formattedTime = `${HH}:${mm}`;

      return formattedTime;
    },
  },
  methods: {
    ...mapActions(["login", "getData2", "getData3", "getData", "createData"]),
    formattedTime24() {
      const timeString = `${this.selectedTime.hh}:${this.selectedTime.mm} ${this.selectedTime.A}`; // Crea la cadena de tiempo con AM/PM

  const momentTime = moment(timeString, 'hh:mm A'); // Analiza la hora en formato 12 horas
      let hour =momentTime.format('HH:mm');
      console.log(hour)      // Obtiene la hora del objeto moment
  return hour;

    },
    loadLastAppointment() {
      let form = {
        url: "appointment/last/"+this.form_update.id,
       
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.lastAppointment = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setDate(date) {
      this.selectedDate = date;
    },
    generateFutureDates() {
      console.log("Generando fechas futuras...");
      this.futureDates = [];
      const today = moment(); // Obtiene la fecha actual con Moment.js
      console.log(today);
      // use isoWeekday (1=Lunes, 7=Domingo) for targetDayOfWeek
      const targetDayOfWeek = this.day_selected.id;

      for (let i = 0; i < 4; i++) {
        const offset = (targetDayOfWeek - today.isoWeekday() + 7) % 7;
        const futureDate = today
          .clone()
          .add(i * 7 + offset, "days"); // Calcula la fecha futura
        this.futureDates.push(futureDate.format("YYYY-MM-DD")); // Formatea la fecha como desees (aquí, 'YYYY-MM-DD')
      }
      console.log(this.futureDates);
    },
    disabledDates() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000)
      );
    },
    formatHour(hour) {
      //format hour with moment js to 12 hours format

      return moment(hour, "HH:mm").format("h:mm A");
    },
    focusPasswordInput() {
      // Enfocar el campo de entrada de la clave
      this.$refs.passwordInput.focus();
    },
    showWarningAlert() {
      Swal.fire({
        title: "Datos incorrectos",
        text: "Ingresa nuevamente a nuestra APP, en la sección CONFIGURACION, y edita los datos de tu perfil para continuar con la reserva de citas",
        icon: "error",
        showCancelButton: false,
        showconfirmButton: false,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#ccc",
        // confirmButtonText: 'Volver a la app'
      });
    },
    nextStep() {
      //force to scroll to top
      window.scrollTo(0, 0);
      if (this.currentStep < 4) {
        this.currentStep++;
      }
    },
    prevStep() {
      //force to scroll to top
      window.scrollTo(0, 0);
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    formatDate2(date) {
      return moment(date).format("DD-MM-YYYY"); // Ejemplo: 27 de Mayo de 2024
    },
    formatDate4(date) {
      return moment(date).format("YYYY-MM-DD"); // Ejemplo: 27 de Mayo de 2024
    },
    formatDate(date) {
      return moment(date).format("DD [de ]MMMM [de] YYYY"); // Ejemplo: 27 de Mayo de 2024
    },
    //selectedDate

    filterVehicles(selectedVehicle) {
      // Update selected vehicle
      this.selectedVehicle = selectedVehicle;
    },
    updateStatus(selectedOption) {
      console.log(selectedOption, "que seleccione");
    },
    loadvehicles(id) {
      let form = {
        url: "vehicle/all",
        params: {
          id_user: id,
          active: 1,
        },
      };

      this.isBusy = true;
      this.getData2(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.vehiclesTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveSchedul(itemvehicle, itemuser, itemshedule) {
      const formattedTime = this.formattedTime;
      console.log(
        "id_user",
        itemuser.id,
        "id_vehicle",
        itemvehicle.id,
        "id_shedule",
        itemshedule.id,
        "date",
        this.formatDate4(this.selectedDate),
        "hour",
        this.formattedTime24()
      );
      Swal.fire({
        title: "¿Está seguro de que desea agendar la cita?",
        // text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ff7600", // Naranja
        cancelButtonColor: "#651366", // Morado
        reverseButtons: true,
        confirmButtonText: "Sí, agendar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          let form = {
            url: "appointment/save",
            data: {
              id_user: itemuser.id,
              id_vehicle: itemvehicle.id,
              id_schedule: this.selectedSchedule.id,
              date: this.formatDate4(this.selectedDate),
              hour: this.formattedTime24(),
            },
          };

          this.createData(form)
            .then((response) => {
              if (response.code === 200) {
                this.deleting = false;
                Swal.fire({
                  title: "Cita agendada",
                  text: "Gracias por tu tiempo, te esperamos en al fecha y hora indicada para tu cita",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 5000,
                });

                this.$router.push("/return");
              } else if (response.code === 409) {
                Swal.fire({
                  title: "Ups! Datos repetidos",
                  text: "Ya tienes una cita en progreso con esos datos",
                  icon: "warning",
                  customClass: {
                    confirmButton: "btn-info my-custom-button", // Estilo de botón personalizado
                    confirmButtonColor: "#ffffff !important", // Color de fondo blanco del botón de confirmación
                    confirmButtonText: "Aceptar",
                  },
                  buttonsStyling: false, // Desactivar el estilo predeterminado de SweetAlert 2
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.deleting = false;
              this.$toaster.warning(
                "Ocurrio un error al registrar los datos, verifica la información registrada"
              );
            });
        }
      });
    },
    loadSchedules() {
      // Limpiar la selección de horario al cambiar de día
      this.selectedSchedule = {};
      
      // Limpiar la selección de hora
      this.selectedHour = null;
      this.selectedTime = null;
      
      let day = null;
      day = this.day_selected.name;
      let form = {
        url: "schedule/all",
        params: {
          active: 1,
          day: day,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.schedulesTmp = response.data;
            this.generateFutureDates();
            // this.hourTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    toggleHorario(horario) {
      this.selectedSchedule = horario;
      // Resetear la hora seleccionada cuando cambia el horario
      this.selectedHour = null;
    },
    
    selectHour(hourValue, hourLabel) {
      this.selectedHour = hourValue;
      
      // Formatear la hora para compatibilidad con el resto del código
      let hour = hourValue;
      let period = "AM";
      
      if (hour >= 12) {
        period = "PM";
        if (hour > 12) {
          hour = hour - 12;
        }
      }
      if (hour === 0) {
        hour = 12;
      }
      
      // Actualizar selectedTime para mantener compatibilidad con el código existente
      this.selectedTime = {
        hh: hour.toString().padStart(2, '0'),
        mm: "00",
        A: period
      };
    },
    isHorarioActive(horario) {
      return this.selectedSchedule.id === horario.id; // Check if active
    },
    loadElements(Token) {
      console.log("Token recibido:", Token);
      let form = {
        // url: 'user/token',
        url: "user/token",
        token: Token,
      };

      this.isBusy = true;
      this.getData3(form)
        .then((response) => {
          // element.created_at = this.formatDate(element.created_at);
          //  element.birthdate = this.formatDate(element.birthdate);
          this.isBusy = false;
          if (response.code === 200) {
            this.form_update = response.data;
            this.loadvehicles(this.form_update.id);
            this.loadLastAppointment();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.image-container {
  /* position: relative;   */
  position: absolute;

  width: 100%;
  /* height: 100vh;   */
  height: 100% !important;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}
@media (min-width: 360px) and (max-height: 670px) {
  .image-container {
    height: 110% !important;
  }
}
@media (min-width: 300px) and (max-height: 900px) {
  .image-container {
    height: 130% !important;
  }
}
@media (min-width: 375px) and (max-height: 667px) {
  .image-container {
    height: 180% !important;
  }
}
@media (min-width: 430px) and (max-height: 932px) {
  .image-container {
    height: 130% !important;
  }
}
@media (min-width: 412px) and (max-height: 915px) {
  .image-container {
    height: 130% !important;
  }
}
@media (min-width: 36px) and (max-height: 740px) {
  .image-container {
    height: 180% !important;
  }
}
.container {
  position: relative; /* Positions card/container on top of image */
  /* Positions card/container vertically centered */
 /* Adjusts horizontal positioning based on card/container width */
  /* background-color: rgba(0, 0, 0, 0.5); */
  /* Example background color for the card/container (optional) */
  /* Example padding for the card/container (optional) */
  color: white; /* Example text color for the card/container (optional) */
  /* Add other styles for your card/container as needed */
}

.multiselect__tags {
  border-radius: 30px !important;
}
.radio-group {
  display: flex; /* Arrange radio buttons side-by-side */
  margin-bottom: 10px; /* Add spacing between radio groups */
  justify-content: center; /* Center radio buttons horizontally */
}

.radio-button {
  display: flex; /* Allow text to be inside the button */
  align-items: center; /* Center text vertically */
  width: 150px; /* Increased width for radio buttons */
  height: 40px; /* Increased height for radio buttons */
  margin-bottom: 5px; /* Add spacing between radio buttons */
  padding: 10px 15px; /* Add padding for better spacing */
  border-radius: 20px; /* Rounded corners */
  cursor: pointer; /* Indicate clickable element */
  transition: background-color 0.3s ease; /* Smooth transition for background color change */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Add subtle shadow */
}

.radio-button input[type="radio"] {
  appearance: none; /* Remove default radio button appearance */
  width: 25px; /* Set radio button width */
  height: 25px; /* Set radio button height */
  border-radius: 50%; /* Make radio button circular */
  margin-right: 10px; /* Add margin between radio button and text */
}

.radio-button input[type="radio"]:checked + .radio-button-text {
  color: white; /* White text for selected radio button */
}

.radio-button {
  background-color: #ff8040; /* Darker orange background for all buttons */
  color: white; /* White text for all buttons */
}

.radio-button:hover {
  background-color: #f8c971; /* Lighter orange background on hover for all buttons */
}

.radio-button input[type="radio"]:checked {
  background-color: #c65300; /* Even darker orange background for selected radio button */
}

.radio-button input[type="radio"]:checked:hover {
  background-color: #c65300; /* Even darker orange background on hover for selected radio button */
}
.btn-light {
  background-color: #c65300 !important;
  border-color: #c65300 !important;
  color: white !important;
}

.available-hours-container {
  max-width: 100%;
  overflow-x: auto;
  padding: 10px;
}

@media (max-width: 768px) {
  .available-hours-container .btn {
    min-width: 90px !important;
    font-size: 0.9rem;
    padding: 8px 12px;
  }
}
</style>
